import { useState } from 'react';
import type { DataSubject } from '@cloudsign/shared';
import { t } from '../../lib/i18n';
import { useCan } from '../../lib/session';
import { PageHeader } from '../../components/ui';
import { Tabs, useTab } from '../sites/Tabs';
import { FindTab } from './FindTab';
import { HoldsTab } from './HoldsTab';
import { JobsTab } from './JobsTab';
import { RequestsTab } from './RequestsTab';
import { RetentionTab } from './RetentionTab';

/** `/manage/data-protection`: find a person, export or erase, jobs, legal holds, retention, requests (docs/modules/data-protection.md s7). */
export function DataProtectionPage() {
  const canExport = useCan('data_protection.export');
  const canErase = useCan('data_protection.erase');
  const canFind = canExport || canErase;
  const tabs = [
    { key: 'requests', label: t('p4dp.tab.requests') },
    ...(canFind ? [{ key: 'find', label: t('p4dp.tab.find') }] : []),
    { key: 'jobs', label: t('p4dp.tab.jobs') },
    { key: 'holds', label: t('p4dp.tab.holds') },
    { key: 'retention', label: t('p4dp.tab.retention') },
  ];
  const [tab, setTab] = useTab(tabs);
  const [openJob, setOpenJob] = useState<string | null>(null);
  const [holdDraft, setHoldDraft] = useState<DataSubject | null>(null);
  return (
    <div className="space-y-4">
      <PageHeader title={t('p4dp.title')} description={t('p4dp.description')} />
      <Tabs tabs={tabs} current={tab} onChange={setTab} label={t('p4dp.tabs')}>
        {tab === 'requests' ? <RequestsTab /> : null}
        {tab === 'find' ? (
          <FindTab
            onJob={(id) => {
              setOpenJob(id);
              setTab('jobs');
            }}
            onHold={(subject) => {
              setHoldDraft(subject);
              setTab('holds');
            }}
          />
        ) : null}
        {tab === 'jobs' ? <JobsTab openId={openJob} onOpen={setOpenJob} /> : null}
        {tab === 'holds' ? <HoldsTab draft={holdDraft} onDraftDone={() => setHoldDraft(null)} /> : null}
        {tab === 'retention' ? <RetentionTab /> : null}
      </Tabs>
    </div>
  );
}
